<div class="component-container">
    <strong *ngIf="levelLabel" class="text-uppercase text-smaller mr-2">{{ levelLabel | translate }}</strong>
    <div class="btn-group-primary-light">
        <button [ngClass]="{'active': level === 1}" (click)="setLevel(1);">1</button>
        <button [ngClass]="{'active': level === 2}" (click)="setLevel(2);">2</button>
        <button [ngClass]="{'active': level === 3}" (click)="setLevel(3);">3</button>
    </div>
</div>